<template>
  <div class="mobile">
    <!-- <a-back-top /> -->
    <Sidebar />
    <Header id="index" :data="allData.mobile?.header" />
    <!-- <LivePlayer /> -->
    <playback id="playback" :data="2025"></playback>
    <About id="about" :data="allData.mobile?.about" />
    <Activity id="activity" :data="allData.mobile?.activity" />
    <Highlight id="highlight" :data="allData.mobile?.highlight" />
    <Agenda id="agenda" :data="agendaInfo" />
    <Lesson id="lesson" :data="allData.mobile?.lesson" />
    <Guest id="guest" :data="allData.mobile?.guest" />
    <News id="news" :data="allData.mobile?.news" />
    <Partner id="partner" :data="partenrInfo" />
    <Business />
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getRecruit } from '@/api/2024/index'
import Sidebar from './iscMobile/sidebar.vue'
import Header from './iscMobile/header.vue'
import playback from '@/components/playback/playback-mobile.vue'
import About from './iscMobile/about.vue'
import Activity from './iscMobile/activity.vue'
import Highlight from './iscMobile/highlight.vue'
import Agenda from './iscMobile/agenda.vue'
import Lesson from './iscMobile/lesson.vue'
import Guest from './iscMobile/guest.vue'
import News from './iscMobile/news.vue'
import Partner from './iscMobile/partner.vue'
import Business from './iscMobile/business.vue'
// import LivePlayer from '../livePlayer/mobile.vue'

const allData = ref({})
const agendaInfo = ref([])
const partenrInfo = ref({})

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getRecruit('dUt4REhnN0o5T1FZY3BSem1DcjRjQT09OjpL0OCuQnEV1ClVXBiET5sa')
    .then((res) => {
      allData.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})

    getRecruit('cGVSTUhOSXo3c1FGVW5ZU1gxMk12QT09OjrxGJpKgbirdzw5PVxz3S6r')
    .then((res) => {
        agendaInfo.value = JSON.parse(res.data.data.data).agenda
    })
    .catch(() => {})

    getRecruit('M1d6ZXZ1RHFieEt2cE1uWk8rYXlxQT09OjpibQ2u5hfB9s/AduqQnBS5')
    .then((res) => {
      partenrInfo.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.mobile {
  position: relative;
  background: rgb(247, 249, 253);
  overflow: hidden;
}
</style>
